import axios from 'axios';
import { getSharedConfig } from '../common/helpers/configs';

export function initAxios() {
  const config = getSharedConfig();
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.timeout = Number(config.timeout);
  axios.defaults.withCredentials = true;
}
